<style lang="less">
  // fonts

  @font-face {
    font-family: "Machina";
    src: local("Machina"),
     url("../src/assets/fonts/Neue-Machina/NeueMachina-Regular.otf") format("opentype");
  }
  @font-face {
    font-family: "Machina";
    font-weight: "bold";
    src: local("Machina"),
     url("../src/assets/fonts/Neue-Machina/NeueMachina-Ultrabold.otf") format("opentype");
  }
  @font-face {
    font-family: "Machina";
    font-weight: "lighter";
    src: local("Machina"),
     url("../src/assets/fonts/Neue-Machina/NeueMachina-Light.otf") format("opentype");
  }

  @import (css) url('https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,400;0,500;0,700;0,900;1,300;1,800&display=swap');
  
  body, html, .v-application{
    font-family: 'Work Sans' !important;
    background: #FAFAFD !important;
  }
  
  .cn-font {
    font-family: "Machina";
    &.bold {
      font-weight: bold;
    }
    &.light {
      font-weight: lighter;
    }
  }

  // end of fonts

  .v-btn {
    &.v-btn--rounded {
      text-transform: none !important;
    }
  }

  .white--background {
    background-color: white;
  }
  .wrap{
    overflow: auto !important;
    white-space: break-spaces !important;
  }
  .cn-wrapper {
    min-height: 100%;
    position: relative;
    .cn-content{
      display: inline-block;
      width: 100%;
      padding: 20px;
      margin-bottom: 100px;
      padding-bottom: 240px
    }
    .cn-footer {
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  }
</style>
<template>
  <v-app id="checkit">
    <v-app-bar app flat fixed color="offWhite">

      <v-btn @click.stop="drawer = !drawer" icon fab absolute left class="ml-2"><v-icon color="primary2">mdi-menu</v-icon></v-btn> 
      <router-link style="margin-left: auto; margin-right: auto" to="/"><img src="../src/assets/images/logo.png" height="60px" class="mt-5 mb-5"/></router-link>        
    </v-app-bar>
    <SideBar ref="sidebar" :trigger="drawer" v-on:change="(c) => { drawer = c }"></SideBar>
    <v-main>
      <div class="cn-wrapper">
        <div class="cn-content">
          <router-view></router-view>      
        </div>
        <div class="cn-footer">
          <Footer></Footer>
        </div>
      </div>
      <v-snackbar right v-model="snackbar" light timeout="1000">
        Demo version - not all features are live
      </v-snackbar>
      <AssessmentNotice></AssessmentNotice>
    </v-main>
  </v-app>
</template>

<script>

  import AssessmentNotice from "@/components/assessment/content/AssessmentNotice"
  import Footer from "@/components/content/Footer"
  import SideBar from "@/components/content/SideBar"

  export default {
    name: 'App',
    components: {
      SideBar,
      Footer,
      AssessmentNotice
    },
    data: () => ({
      snackbar: false,
      drawer: true,
    }),
    computed: {
      isMobile(){
        return (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs)
      }
    },
    created(){
      const self = this;
      document.title = "CHECK IT NOW - Analyse klinischer Versorgungsprozesse";
      self.$store.dispatch("auth/setView", "user").catch( e => e);
      // document.addEventListener( "click", () => {
      //   self.snackbar = true;
      // } )
    },
    watch: {
      isMobile: {
        immediate: true,
        handler(){
          if( this.isMobile ){
            this.drawer = false;
          }
        }
      }
    }
  };
</script>
